export const fetchAppDetails = async () => {
  try {
    const response = await fetch(
      "https://api.formaxpay.com/restapi/android_master",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: "4",
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching app details:", error);
    throw error;
  }
};
